import React from 'react';
import loadable from '@loadable/component';

const EmojiConstants = loadable.lib(() => import(/* webpackPrefetch: true */ 'Shared/constants/emojiConstants'));
const NimbleEmojiIndex = loadable.lib(
  () => import(/* webpackPrefetch: true */ 'emoji-mart/dist/utils/emoji-index/nimble-emoji-index')
);

export function withEmojiData(WrappedComponent) {
  return props => (
    <EmojiConstants>
      {({ emojisCollectionName, emojisCollectionData }) => (
        <WrappedComponent set={emojisCollectionName} data={emojisCollectionData} {...props} />
      )}
    </EmojiConstants>
  );
}

export function withEmojiIndex(WrappedComponent) {
  return withEmojiData(({ data, ...props }) => (
    <NimbleEmojiIndex>
      {({ default: EmojiIndex }) => {
        const emojiIndex = new EmojiIndex(data);
        return <WrappedComponent emojiIndex={emojiIndex} {...props} />;
      }}
    </NimbleEmojiIndex>
  ));
}
